<template>
  <a-modal v-model="modalVisible" :title="modalTitle" :width="660" :centered="true">
    <template slot="footer">
      <a-button v-if="showType=='add'||showType=='edit'" @click="modalVisible=false">取消</a-button>
      <a-button type="primary" @click="confirm">确认</a-button>
    </template>
    <a-form-model ref="modalForm" :model="formDatas" :rules="formRules" :label-col="{span:7}" :wrapper-col="{span:14}">
      <a-form-model-item label="事件代码" prop="thirdeventcode">
        <a-input v-model.trim="formDatas.thirdeventcode" :disabled="showType=='detail'" />
      </a-form-model-item>
      <a-form-model-item label="事件名称" prop="thirdeventname">
        <a-input v-model.trim="formDatas.thirdeventname" :disabled="showType=='detail'" />
      </a-form-model-item>
      <a-form-model-item label="参数模式" prop="eventtype">
        <a-select v-model="formDatas.eventtype" style="width: 180px;" :disabled="showType=='detail'">
          <a-select-option value="">请选择</a-select-option>
          <a-select-option v-for="(item, index) in eventOptions" :key="index" :value="item.key">{{item.value}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="关联标准事件代码" prop="eventcode">
        <a-input v-model.trim="formDatas.eventcode" :disabled="showType=='detail'" />
      </a-form-model-item>
      <a-form-model-item label="描述" prop="thirdeventdesc">
        <a-input v-model.trim="formDatas.thirdeventdesc" :disabled="showType=='detail'" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
import {eventOptions,eventTips} from '@/json/wlwhistory'
import { addThirdEvent, modifyThirdevent } from 'A/ai.js'
export default {
  props: {
    visible: {
      default: false
    },
    showType: {
      default: 'add'
    },
    detailData: {
      default: null
    },
  },
  data() {
    return {
      eventOptions,
      eventTips,
      modalVisible: false,
      formDatas: {
        thirdeventid: '',
        thirdeventcode: '',
        thirdeventname: '',
        eventtype: '',
        eventcode: '',
        platformtype: '1',
        thirdeventdesc: '',
      },
      formRules: {
        thirdeventcode: [{required: true, message: '请输入事件代码'}],
        thirdeventname: [{required: true, message: '请输入事件名称'}],
        eventtype: [{required: true, message: '请选择事件类型'}],
      }
    }
  },
  computed: {
    modalTitle() {
      if(this.showType == 'add') {
        return '新增'
      }else if(this.showType == 'edit') {
        return '修改'
      }else if(this.showType == 'detail') {
        return '详情'
      }else {
        return '';
      }
    }
  },
  watch: {
    visible(val) {
      if(val) {
        this.modalVisible = true;
        this.initDetail();
      }
    },
    modalVisible(val) {
      if(!val) {
        this.resetDatas();
        this.$emit('update:visible', false);
      }
    }
  },
  created() {
    this.modalVisible = this.visible;
  },
  methods: {
    initDetail() {
      if(this.detailData && (this.showType == 'edit' || this.showType == 'detail')) {
        this.$nextTick(() => {
          for(let key in this.formDatas) {
            this.formDatas[key] = this.detailData[key]||'';
          }
        })
      }
    },
    resetDatas() {
      this.formDatas.thirdeventid = '';
      this.$refs.modalForm.resetFields();
    },
    confirm() {
      // success fail
      if(this.showType == 'add' || this.showType == 'edit') {
        this.$refs.modalForm.validate(valid => {
          if(valid) {
            this.showLoading();
            let params = {
              ...this.formDatas
            };
            if(this.showType == 'add') {
              addThirdEvent(params).then(res => {
                this.hideLoading();
                if(res && res.returncode == '0') {
                  this.$message.success('操作成功');
                  this.$emit('get-operation-result', 'success', '操作成功');
                  this.modalVisible = false;
                }else {
                  this.$message.error(res.errormsg||'操作失败');
                }
              })
            }else {
              modifyThirdevent(params).then(res => {
                this.hideLoading();
                if(res && res.returncode == '0') {
                  this.$message.success('操作成功');
                  this.$emit('get-operation-result', 'success', '操作成功');
                  this.modalVisible = false;
                }else {
                  this.$message.error(res.errormsg||'操作失败');
                }
              })
            }
          }else {
            return false;
          }
        })
      }else {
        this.modalVisible = false;
      }
    }
  }
}
</script>